import React, { useContext, useState } from 'react'
import AvaliacoesCentroEsportivo from '../../../Modais/AvaliacoesCentroEsportivo/AvaliacoesCentroEsportivo'
import { Box, Typography, Chip, Divider, Grid } from '@mui/material'
import { HiClipboardDocumentList } from 'react-icons/hi2'
import { RiDiscountPercentFill } from 'react-icons/ri'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { ChatContext } from '../../../../contexts/ChatContext'
import RouterHook from '../../../../contexts/RouterHook'
import { isSuperAvaliado } from '../../../../utils'
import { starAnimated } from '../../../../assets'
import { IoChatbubbles } from 'react-icons/io5'
import { FaStar, FaTicket } from 'react-icons/fa6'
import { Cupons } from '../../../Modais'
import ListQuadras from './ListQuadras'
import { Stack } from '@mui/system'
import Lottie from 'lottie-react'
import { Alerts } from '../../../Simple'
import { LocalStorage } from '../../../../services'
import { AuthContext } from '../../../../contexts/AuthContext'
import { CompTorneio } from '../../../Complex'

export default function Contact() {
  const serverRouter = RouterHook()

  const { sttAuthCtx } = useContext(AuthContext)
  const { userUCtx } = useContext(UsuarioContext)
  const { sttPg, actionsCtxEmps } = useContext(EmpresasContext)
  const { sttChatCtx, actionsChatCtx } = useContext(ChatContext)

  const [mostrarAvaliacoes, setMostrarAvaliacoes] = useState(false)
  function switchMostrarAvaliacoes() {
    setMostrarAvaliacoes(!mostrarAvaliacoes)
    actionsCtxEmps.clearPaginationAvaliacoes()
  }

  const [mostrarCupons, setMostrarCupons] = useState(false)

  function switchMostrarCupons() {
    setMostrarCupons(!mostrarCupons)
  }

  const emp = sttPg.empresa

  function GoChat() {
    if (!sttAuthCtx.isLogged) {
      return Alerts.question(
        'Aviso',
        'Para acessar o chat é necessário estar logado. Deseja fazer login agora?',
        () => {
          serverRouter('login')
        },
      )
    }
    if (sttChatCtx.modeChat !== 'diretos') actionsChatCtx.handleModeChat('diretos')
    LocalStorage.set('chat-selected', { mode: 'diretos', id: emp.idempresa })
    serverRouter('chat', userUCtx.usuario.idusuario)
  }

  return (
    <div
      style={{
        height: '25vh',
        backgroundImage: `url(${emp.urlFoto + emp.foto})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {mostrarAvaliacoes && (
        <AvaliacoesCentroEsportivo
          onClose={switchMostrarAvaliacoes}
          open={mostrarAvaliacoes}
          width='90%'
          height='auto'
        />
      )}
      {mostrarCupons && <Cupons open={mostrarCupons} onClose={switchMostrarCupons} width='90%' />}
      {isSuperAvaliado(emp) && (
        <Lottie
          animationData={starAnimated}
          loop={false}
          style={{
            width: '37px',
            height: '37px',
            position: 'absolute',
            top: '19.5vh',
            right: '2vh',
            zIndex: 1,
          }}
        />
      )}
      <Box
        sx={{
          borderRadius: 6,
          mt: '22vh',
          overflow: 'hidden',
          backgroundColor: 'white',
          width: '100%',
        }}
      >
        <Box sx={{ padding: 2 }}>
          <Typography color='black' variant='h5' fontFamily='integral-cf-bold'>
            {emp.nome}
          </Typography>
          <Typography color={'text.secondary'} variant='body2'>
            {emp.descricao}
          </Typography>
        </Box>
        <Stack
          direction='row'
          spacing={0.2}
          sx={{
            mt: 1,
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            gap: 1,
            p: 1,
          }}
        >
          {emp.mediaAvaliacoes > 0 && emp.quantidadeAvaliacoes > 0 && (
            <Chip
              clickable
              sx={{
                paddingY: 2,
                paddingX: 1,
                backgroundColor: '#f0f0f0',
                borderColor: 'transparent',
              }}
              color='warning'
              variant='outlined'
              onClick={() => switchMostrarAvaliacoes()}
              icon={<FaStar size={18} style={{ marginBottom: '3px' }} />}
              label={`${emp.mediaAvaliacoes.toFixed(1)} (${emp.quantidadeAvaliacoes})`}
            />
          )}
          <Chip
            clickable
            sx={{
              paddingY: 2,
              paddingX: 1,
              backgroundColor: '#f0f0f0',
              borderColor: 'transparent',
            }}
            color='primary'
            variant='outlined'
            label='Mensagem Diretas'
            icon={<IoChatbubbles size={18} style={{ marginBottom: '3px' }} />}
            onClick={() => {
              GoChat()
            }}
          />
          {emp.aceitaDiarias && (
            <Chip
              clickable
              sx={{
                paddingY: 2,
                paddingX: 1,
                backgroundColor: '#f0f0f0',
                borderColor: 'transparent',
              }}
              icon={<FaTicket size={18} style={{ marginBottom: '3px' }} />}
              label='Diárias'
              onClick={() => {
                if (!sttAuthCtx.isLogged)
                  return Alerts.question(
                    'Aviso',
                    'Para acessar as diárias é necessário estar logado. Deseja fazer o login agora?',
                    () => serverRouter('login'),
                  )
                actionsCtxEmps.handleSttPg('modePg', 'diarias')
              }}
              color='primary'
              variant='outlined'
            />
          )}

          {sttAuthCtx.isLogged && emp.aceitaCupom && (
            <Chip
              sx={{
                paddingY: 2,
                paddingX: 1,
                backgroundColor: '#f0f0f0',
                borderColor: 'transparent',
              }}
              icon={<RiDiscountPercentFill size={18} style={{ marginBottom: '3px' }} />}
              label='Cupons'
              clickable
              onClick={() => switchMostrarCupons()}
              color='primary'
              variant='outlined'
            />
          )}
          {emp.informacoesGerais && emp.informacoesGerais.length > 0 && (
            <Chip
              sx={{
                paddingY: 2,
                paddingX: 1,
                backgroundColor: '#f0f0f0',
                borderColor: 'transparent',
              }}
              icon={<HiClipboardDocumentList />}
              label='Informações adicionais'
              clickable
              onClick={() => {
                Alerts.swal('warning', 'Informações adicionais', emp.informacoesGerais)
              }}
              color='primary'
              variant='outlined'
            />
          )}
        </Stack>
        <Divider />
      </Box>
      {
        // Só mostra se tiver pelo menos um torneio
        sttPg.empresa.torneios?.length && (
          <Grid item xs={12} sx={{ height: 'auto', width: '100%', padding: '5px 10px' }}>
            <Typography component='p' className='text-title-comp'>
              Competições
            </Typography>
            <Box sx={stDesk.containGridTorneios}>
              {sttPg.empresa.torneios.map((tr, idx) => (
                <React.Fragment key={idx}>
                  <CompTorneio
                    nomeEmpresa={sttPg.empresa.nome}
                    fotoEmpresa={sttPg.empresa.urlFoto + sttPg.empresa.foto}
                    torneio={tr}
                    onClick={() => {
                      serverRouter('torneio', tr.idtorneio)
                    }}
                  />
                </React.Fragment>
              ))}
            </Box>
          </Grid>
        )
      }
      <ListQuadras />
    </div>
  )
}

const stDesk = {
  containGridTorneios: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '10px',
    overflow: 'auto',
  },
}
